export const numberMaskFormat = {
  mask: '9.###.###.###.###.###',
  tokens: {
    9: { pattern: /[0-9]/, repeated: true },
  },
  reversed: true,
}
